export const TEXT_LAYER_EVENT = {
    CANCEL_SHAPE_TEXT: 'text-layer/cancel-shape-text',
};
